import { useMemo, useState } from 'react';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';
import { news } from '@/mocks/news';
import NewsCard from '@/components/base/NewsCard';
import EmptyState from '@/components/base/EmptyState';

const tabs = ['全部', '影评', '新闻', '专题', '预告'];
const PAGE_SIZE = 4;

export default function News() {
  const [tab, setTab] = useState('全部');
  const [visible, setVisible] = useState(PAGE_SIZE);

  useDocumentTitle('影视资讯 - 蜜桃网最新电影电视剧新闻与影评', {
    description:
      '蜜桃网影视资讯频道，提供最新电影电视剧新闻、专业影评、专题报道与预告片资讯，第一时间了解影视圈动态。',
    keywords: '蜜桃网,影视资讯,电影新闻,电视剧资讯,影评,影视专题',
  });

  const filtered = useMemo(
    () => (tab === '全部' ? news : news.filter((a) => a.category === tab)),
    [tab],
  );

  const shown = filtered.slice(0, visible);
  const hasMore = visible < filtered.length;

  const changeTab = (value: string) => {
    setTab(value);
    setVisible(PAGE_SIZE);
  };

  return (
    <div className="mx-auto w-full px-4 py-8 md:px-8 md:py-10">
      <div className="mb-8">
        <h1 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">影视资讯</h1>
        <p className="mt-3 max-w-3xl text-sm leading-relaxed text-foreground-600">
          汇集最新影视新闻、专业影评、深度专题与预告资讯，帮你快速掌握影视圈的最新动态。
        </p>
      </div>

      <div className="mb-6 flex flex-wrap gap-2">
        {tabs.map((t) => (
          <button
            key={t}
            type="button"
            onClick={() => changeTab(t)}
            className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
              tab === t
                ? 'bg-primary-500 text-background-50'
                : 'bg-background-100 text-foreground-700 hover:bg-background-200'
            }`}
          >
            {t}
          </button>
        ))}
      </div>

      {shown.length > 0 ? (
        <>
          <div className="flex flex-col gap-4">
            {shown.map((article) => (
              <NewsCard key={article.id} article={article} />
            ))}
          </div>
          <div className="mt-8 flex justify-center">
            {hasMore ? (
              <button
                type="button"
                onClick={() => setVisible((v) => v + PAGE_SIZE)}
                className="whitespace-nowrap rounded-full bg-primary-500 px-8 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                加载更多
              </button>
            ) : (
              <span className="text-sm text-foreground-400">— 已经到底啦 —</span>
            )}
          </div>
        </>
      ) : (
        <EmptyState
          title="该分类下暂时没有资讯"
          description="换个标签看看，或者浏览全部影视资讯。"
          actionLabel="查看全部资讯"
          onAction={() => changeTab('全部')}
        />
      )}
    </div>
  );
}